var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShow = function SvgIconShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.819,
    r: 1.582,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 12.036c-2.451 0-4.507-1.356-5.349-3.218C3.493 6.956 5.549 5.6 8 5.6s4.507 1.356 5.349 3.218c-.842 1.862-2.898 3.218-5.349 3.218"
  })));
};
export { SvgIconShow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOC4wMDAwNiIgY3k9IjguODE4NTQiIHI9IjEuNTgxODIiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDEyLjAzNjRDNS41NDg2NSAxMi4wMzY0IDMuNDkyNjQgMTAuNjgwMiAyLjY1MTA0IDguODE4MThDMy40OTI2NCA2Ljk1NjE3IDUuNTQ4NjUgNS42IDggNS42QzEwLjQ1MTQgNS42IDEyLjUwNzQgNi45NTYxNyAxMy4zNDkgOC44MTgxOEMxMi41MDc0IDEwLjY4MDIgMTAuNDUxNCAxMi4wMzY0IDggMTIuMDM2NFoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";